import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {SettingsEmailMergeService} from '../../services/settings-email-merge.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'settings-email-merge.component.html'
})
export class SettingsEmailMergeComponent implements OnInit, OnDestroy {

    constructor(public settingsEmailMergeService: SettingsEmailMergeService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.settingsEmailMergeService.getUserRoles();
        this.settingsEmailMergeService.firstTimeLoading = true;

        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => this.settingsEmailMergeService.tabId = this.urlService.queryParams['tab']
                ),
                flatMap(
                    () => this.settingsEmailMergeService.getCorporationsByQueryParams(true)
                        .pipe(
                            takeUntil(this.urlService.instantOnUrlChange)
                        )
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allSettingsDirectory');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.settingsEmailMergeService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.settingsEmailMergeService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/settings-email-merge.component.ts